<template>
  <div>
    <vxe-card>
      <div slot="title">
        <vxe-button content="menu.addressManagement" mode="text" status="primary"/>
      </div>
      <template #extra>
        <vxe-button content="button.taken" icon="vxe-icon-search" mode="text" status="primary" @click="onAddressSelect"/>
        <address-modal ref="addressModal" @change="onAddressChange"/>
      </template>
      <a-form-model ref="form" :colon="false" :label-col="labelCol" :model="address" :wrapper-col="wrapperCol">
        <a-row style="margin-left: -2%;margin-right: 2%">
          <a-col :span="6">
            <a-form-model-item :label="$t('business.label.company')">
              <vxe-input v-model="address.contactInfo.company" disabled placeholder="" style="width: 100%"/>
            </a-form-model-item>
          </a-col>
          <a-col :span="6">
            <a-form-model-item :label="$t('business.label.contactor')">
              <vxe-input v-model="address.contactInfo.contactor" disabled placeholder="" style="width: 100%"/>
            </a-form-model-item>
          </a-col>
          <a-col :span="6">
            <a-form-model-item :label="$t('business.label.phone')">
              <vxe-input v-model="address.contactInfo.phone" disabled placeholder="" style="width: 100%"/>
            </a-form-model-item>
          </a-col>
          <a-col :span="6">
            <a-form-model-item :label="$t('business.label.email')">
              <vxe-input v-model="address.contactInfo.email" disabled placeholder="" style="width: 100%"/>
            </a-form-model-item>
          </a-col>
          <a-col :span="6">
            <a-form-model-item :label="$t('business.label.idType')">
              <vxe-select v-model="address.contactInfo.idType" :options="idTypes" disabled placeholder="" style="width: 100%"/>
            </a-form-model-item>
          </a-col>
          <a-col :span="6">
            <a-form-model-item :label="$t('business.label.idNumber')">
              <vxe-input v-model="address.contactInfo.idNumber" disabled placeholder="" style="width: 100%"/>
            </a-form-model-item>
          </a-col>
          <a-col :span="6">
            <a-form-model-item :label="$t('business.label.country')">
              <vxe-input v-model="address.addressInfo.country" disabled placeholder="" style="width: 100%"/>
            </a-form-model-item>
          </a-col>
          <a-col :span="6">
            <a-form-model-item :label="$t('business.label.province')">
              <vxe-input v-model="address.addressInfo.province" disabled placeholder="" style="width: 100%"/>
            </a-form-model-item>
          </a-col>
          <a-col :span="6">
            <a-form-model-item :label="$t('business.label.city')">
              <vxe-input v-model="address.addressInfo.city" disabled placeholder="" style="width: 100%"/>
            </a-form-model-item>
          </a-col>
          <a-col :span="6">
            <a-form-model-item :label="$t('business.label.district')">
              <vxe-input v-model="address.addressInfo.district" disabled placeholder="" style="width: 100%"/>
            </a-form-model-item>
          </a-col>
          <a-col :span="6">
            <a-form-model-item :label="$t('business.label.town')">
              <vxe-input v-model="address.addressInfo.town" disabled placeholder="" style="width: 100%"/>
            </a-form-model-item>
          </a-col>
          <a-col :span="6">
            <a-form-model-item :label="$t('business.label.village')">
              <vxe-input v-model="address.addressInfo.village" disabled placeholder="" style="width: 100%"/>
            </a-form-model-item>
          </a-col>
          <a-col :span="6">
            <a-form-model-item :label="$t('business.label.street')">
              <vxe-input v-model="address.addressInfo.street" disabled placeholder="" style="width: 100%"/>
            </a-form-model-item>
          </a-col>
          <a-col :span="6">
            <a-form-model-item :label="$t('business.label.postalCode')">
              <vxe-input v-model="address.addressInfo.postalCode" disabled placeholder="" style="width: 100%"/>
            </a-form-model-item>
          </a-col>
          <a-col :span="24">
            <a-form-model-item :label="$t('business.label.detailAddress')" :label-col="{ span: 2 }" :wrapper-col="{ span: 22 }">
              <vxe-textarea v-model="address.addressInfo.detailAddress" :autosize="{ minRows: 2 }" disabled placeholder=""/>
            </a-form-model-item>
          </a-col>
        </a-row>
      </a-form-model>
    </vxe-card>
  </div>
</template>

<script>
import { findOne } from '@/api/Api'
import { Address } from '@/api/dto/common/Address'
import AddressModal from '@/views/modal/AddressModal.vue'

export default {
  name: 'AddressDetail',
  components: { AddressModal },
  data() {
    return {
      loading: false,
      address: new Address(),
      idTypes: [
        { label: '身份证', value: '1' },
        { label: '军官证', value: '2' },
        { label: '护照', value: '3' },
        { label: '其他', value: '4' }
      ],
      labelCol: { span: 8 },
      wrapperCol: { span: 16 }
    }
  },
  methods: {
    onAddressSelect() {
      this.$refs.addressModal.open()
    },
    onAddressChange(value) {
      this.address = new Address(value[0])
      this.$emit('change', this.address)
    },
    refresh(id) {
      this.loading = true
      findOne('addressFactory', { id: id }).then(res => {
        if (res.success) {
          this.address = new Address(res.result)
        }
      }).finally(() => this.loading = false)
    }
  }
}
</script>